<template>
  <div style="direction: ltr !important;min-height: 500px">
    <div id="viewer" />
  </div>
</template>

<script>
  // import dataset from '../../../../../../public/Demo.json'
  // import fa from '../../../../../../reports/fa.xml'
  export default {
    name: 'PrintDocument',
    props: ['dataProp', 'reportProp', 'resourceProp'],
    data () {
      return {
      }
    },
    watch: {
      dataProp () {
        this.print()
      },
      reportProp () {
        this.print()
      },
      resourceProp () {
        this.print()
      },
    },
    mounted: function () {
      var report = document.createElement('script')
      var viewer = document.createElement('script')
      report.setAttribute('src', 'https://abr.abriron.com/stimulsoft/stimulsoft.reports.js')
      viewer.setAttribute('src', 'https://abr.abriron.com/stimulsoft/stimulsoft.viewer.js')
      document.head.appendChild(report)
      document.head.appendChild(viewer)
      var app = this
      setTimeout(function () { app.print() }, 1000)
    },
    methods: {
      print () {
        var options = new window.Stimulsoft.Viewer.StiViewerOptions()
        window.Stimulsoft.Base.Localization.StiLocalization.setLocalizationFile('../fa.xml')
        options.appearance.Localization = 'fa'
        options.appearance.rightToLeft = true
        options.appearance.scrollbarsMode = true
        options.toolbar.showAboutButton = false
        window.Stimulsoft.Base.StiFontCollection.addOpentypeFontFile(window.location.origin + '/font/IRANSans(FaNum).ttf', 'IRANSans')

        var viewer = new window.Stimulsoft.Viewer.StiViewer(options, 'StiViewer', false)
        var report = new window.Stimulsoft.Report.StiReport()
        // Register DataSet object
        if (this.reportProp) {
          report.loadFile(window.location.origin + '/reportViewer/reports/' + this.reportProp + '.mrt')
        }
        report.dictionary.databases.clear()
        if (this.dataProp) {
          report.regData((this.resourceProp ? this.resourceProp : 'demo'), this.reportProp, JSON.stringify(this.dataProp))
        }
        viewer.report = report
        viewer.Localization = 'fa'
        viewer.renderHtml('viewer')
        viewer.jsObject.controls.menus.printMenu.items.PrintPdf.style.display = 'none'
        // report.renderAsync(function () {
        //   report.print()
        // })
      },
    },
  }
</script>

<style scoped>

</style>
